package dev.youndie.site

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode

@InitSilk
fun initSilk(ctx: InitSilkContext) {
    // Dark only. All visual styling lives in `resources/public/site.css`.
    ctx.config.initialColorMode = ColorMode.DARK
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    // Deliberately no Silk `Surface` here: we let site.css own the page background
    // so the terminal theme isn't fighting Silk's palette.
    SilkApp {
        content()
    }
}
